import { useEffect, useRef, useState } from 'react';

import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';
import { GLOBAL } from 'saddlebag-browser';

import { BreadcrumbsSection } from './BreadcrumbsSection/BreadcrumbsSection';
import { DestinationExplorer } from './DestinationExplorer/DestinationExplorer';
import { Hero } from './Hero/Hero';
import { StatSummary } from './StatSummary/StatSummary';

import STYLES from './FlightPriceMap.module.scss';

const cls = cssModules(STYLES);

export const FlightPriceMap = () => {
  const [showMap, setShowMap] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    if (ref.current) {
      setHeaderHeight(ref.current.getBoundingClientRect().top);
    }
  }, []);

  useEffect(() => {
    ref.current?.style.setProperty('--header-height', `${headerHeight}px`);
  }, [headerHeight]);

  return (
    <div
      ref={ref}
      className={cls('travelConfidenceMap', showMap ? 'travelConfidenceMapMapView' : undefined)}
    >
      {!showMap && <BreadcrumbsSection />}
      {!showMap && <Hero />}
      {!showMap && <StatSummary />}
      <DestinationExplorer
        showMap={showMap}
        onShowMap={() => {
          setShowMap(true);
          GLOBAL.getWindow()?.scrollTo(0, 0);
        }}
        onShowList={() => {
          setShowMap(false);
          GLOBAL.getWindow()?.scrollTo(0, 0);
        }}
      />
    </div>
  );
};
